import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface ScannerState {
   isSwapFlowScannerActive: boolean
}

export const initialState: ScannerState = {
   isSwapFlowScannerActive: false,
}

const scannerSlice = createSlice({
   name: "scanner",
   initialState,
   reducers: {
      setSwapFlowScannerActive(state, action: PayloadAction<boolean>) {
         state.isSwapFlowScannerActive = action.payload
      },
   },
})

export const { setSwapFlowScannerActive } = scannerSlice.actions

export default scannerSlice.reducer
